<template>
  <HeaderContent title="Guest" />
  <ActionContent
    ctaText="Add Guest"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <GuestStatistics title="Guest Statistics" :data="statistics" />
  <GuestForm
    :modal="modal"
    :guestData="guest"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <GuestFilter
    :modalFilter="modalFilter"
    @update:modalFilter="modalFilter = $event"
  />
  <GuestConfirm
    title="Confirmation"
    :uuid="guestUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(guestUuid)"
  >
    <template #text>Are you sure to delete this data ?</template>
  </GuestConfirm>
  <GuestDataTable
    :data="guests"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import { ref, inject, onMounted } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContentGuest.vue";
import _ from "lodash";
import GuestForm from "./GuestForm.vue";
import GuestFilter from "./GuestFilter.vue";
import GuestConfirm from "@/components/ModalDialog.vue";
import GuestStatistics from "@/components/StatisticData.vue";
import GuestDataTable from "@/components/DataTable.vue";
import iconForeign from "../../../public/icons/user-cowboy.svg";
import iconLocal from "../../../public/icons/people-roof.svg";
import iconStay from "../../../public/icons/street-view.svg";
import iconOveral from "../../../public/icons/square-poll-vertical.svg";
//import guestDateFormatter from "@/composable/guestDateFormatter.js";

//alternatif best case -! { getFormattedDate, getFormattedDateTime } utk panggil 2 format sekaligus
import { getFormattedDateTime } from '@/composable/getDateTimeFormatter';



export default {
  components: {
    HeaderContent,
    ActionContent,
    GuestForm,
    GuestFilter,
    GuestConfirm,
    GuestStatistics,
    GuestDataTable,
  },
  setup() {
    const repositories = inject("repositories");
    const guestRepository = repositories ? repositories.guests : null;

    const modal = ref(false);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const currentPage = ref(1);
    const guestUuid = ref(null);
    const guest = ref({});
    const guests = ref([]);
    const headers = ref([
      {
        key: "no",
        label: "#",
      },
      {
        key: "identity_number",
        label: "ID/Passport",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "fullname",
        label: "Name",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "nationality",
        label: "Nationality",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "phone",
        label: "Contact No",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "city",
        label: "City",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
      },
      {
        key: "address",
        label: "Address",
        sortable: true,
      },
      {
        key: "created_ats",
        label: "Registered On",
        sortable: true,
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);
    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);
    const statistics = ref([]);

    const getAll = async (params) => {
      const getAlias = (x) => {
        return _.upperCase(x[0]) + x.slice(1);
      };
      await guestRepository
        .getAll(params)
        .then((res) => {
          console.log("Statistics Data:", res.data.statistics);
          guests.value = res.data.data.map((i) => ({
            ...i,
            fullname: getAlias(i.alias) + ". " + i.fullname,
            created_ats: getFormattedDateTime(i.created_at),
          }));
          statistics.value = [
            {
              label: "Total",
              key: "Foreign Guest",
              value: res.data.statistics.foreign,
              color: "info",
              icon: iconForeign,
            },
            {
              label: "Total",
              key: "Local Guest",
              value: res.data.statistics.local,
              color: "primary",
              icon: iconLocal,
            },
            {
              label: "Total",
              key: "Staying Guest",
              value: res.data.statistics.staying,
              color: "primary",
              icon: iconStay,
            },
            {
              label: "Total",
              key: "Overall Guest",
              value: res.data.statistics.total,
              color: "primary",
              icon: iconOveral,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const getById = async (uuid) => {
      await guestRepository
        .getById(uuid)
        .then((res) => {
          guest.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const updateModal = (newValue) => {
      modal.value = newValue;
      guest.value = {};
    };
    const showModal = () => {
      modal.value = true;
    };
    const showConfirmModal = async (uuid) => {
      modalConfirm.value = true;
      guestUuid.value = uuid;
      console.log(guestUuid.value);
    };
    const deleteData = async (uuid) => {
      await guestRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await guestRepository
        .search(keyword)
        .then((res) => {
          guests.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };
    onMounted(() => {
      getAll();
    });
    return {
      getAll,
      getById,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      guestUuid,
      guests,
      guest,
      headers,
      modal,
      modalFilter,
      modalConfirm,
      currentPage,
      customActions,
      statistics,
      searchData,
    };
  },
};
</script>

<style></style>
